module.exports = __webpack_public_path__ + "6d1504ed3164ecc1a0f68e0599baebdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/default.png
// module id = 39
// module chunks = 0